export {
	NgSelectComponent,
	NG_SELECT_DEFAULT_CONFIG
} from './ng-select/ng-select.component';
export { NgSelectModule } from './ng-select/ng-select.module';
export { NgOption, NgSelectConfig } from './ng-select/ng-select.types';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/libs/@ng-select/index.ts